/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Memoizes a selector that only cares about state and never uses ownProps
 */

import { undefinedState } from './memoizeSelector'
import { Selector } from './types'

// Similar to memoizeSelector except that it _only_ considers state.
export const memoizeState = <State extends object | undefined, Result>(
  func: Selector<[State], Result>
) => {
  const cache = new WeakMap()

  return (state: State): Result => {
    const key = state ?? undefinedState
    if (!cache.has(key)) {
      cache.set(key, func(state))
    }
    return cache.get(key)
  }
}
